module.exports = __webpack_public_path__ + "static/media/Skorupi_gaussian2.d6f9682f.png";